import { axiosInstance } from "../../../api/axiosInstance";
import { FacultyFormRequest, FacultyFormResponse, FacultyListItem } from "../types";

// The backend drops empty lists and nulls from JSON (jackson non_empty) — put them back.
const normalize = (faculty: FacultyFormResponse): FacultyFormResponse => ({
  ...faculty,
  email: faculty.email ?? "",
  assignments: faculty.assignments ?? [],
  academicYear: faculty.academicYear ?? null,
});

// Creates the staff, faculty, login user and the active-year assignments.
export async function createFaculty(request: FacultyFormRequest): Promise<FacultyFormResponse> {
  const response = await axiosInstance.post<FacultyFormResponse>("/faculties", request);
  return normalize(response.data);
}

// Details + active-year assignments, for the edit form.
export async function getFacultyForm(id: number): Promise<FacultyFormResponse> {
  const response = await axiosInstance.get<FacultyFormResponse>(`/faculties/${id}/form`);
  return normalize(response.data);
}

// Saves details and replaces the active-year assignments (unticked ones are deleted).
export async function updateFaculty(id: number, request: FacultyFormRequest): Promise<FacultyFormResponse> {
  const response = await axiosInstance.put<FacultyFormResponse>(`/faculties/${id}`, request);
  return normalize(response.data);
}

// Faculty List: every faculty with what they teach in the active year, in one call.
export async function getFacultyList(): Promise<FacultyListItem[]> {
  const response = await axiosInstance.get<FacultyListItem[]>("/faculties/list");
  return response.data.map((faculty) => ({
    ...faculty,
    academicYear: faculty.academicYear ?? null,
    teaches: (faculty.teaches ?? []).map((grade) => ({
      ...grade,
      sections: (grade.sections ?? []).map((section) => ({ ...section, subjects: section.subjects ?? [] })),
    })),
  }));
}
